export const orderEmail = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Sent",
    value: "sent",
  },
  {
    label: "Failed",
    value: "failed",
  },
];
export const verifyValues = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Verified",
    value: true,
  },
  {
    label: "Unverified",
    value: false,
  },
];

export const verifyValuesAffiliate = [
  {
    label: "Approved",
    value: "active",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
];
export const affiliateStatus = [
  {
    label: "Pending",
    value: "inactive",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
];
export const commissionffiliate = [
  {
    label: "Initial",
    value: "initial",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Paid",
    value: "paid",
  },
];
export const withdrawffiliate = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Paid",
    value: "paid",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
];

export const statusValues = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Payment Pending",
    value: "payment-pending",
  },
  {
    label: "Confirmed",
    value: "confirmed",
  },
  {
    label: "Processing",
    value: "processing",
  },
  {
    label: "Shipping",
    value: "shipping",
  },
  {
    label: "Delivered",
    value: "delivered",
  },
  {
    label: "Canceled",
    value: "canceled",
  },
  {
    label: "Refunded",
    value: "refunded",
  },
];

export const touchSourceValues = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Meta",
    value: "meta",
  },
  {
    label: "Google Ads",
    value: "google_ads",
  },
  {
    label: "Microsoft Ads",
    value: "microsoft_ads",
  },
  {
    label: "TikTok",
    value: "tiktok",
  },
  {
    label: "Twitter / X",
    value: "twitter",
  },
  {
    label: "Organic",
    value: "organic",
  },
  {
    label: "Direct",
    value: "direct",
  },
  {
    label: "Referral",
    value: "referral",
  },
];
